import React, {Component} from 'react';

import configureStore from './store/configureStore';
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";

import {basename} from "./env";
import initialStore from "./store/initialStore";
import {Provider} from "react-redux";
import RootRoute from "./containers/RootRoute";
import {ThemeProvider} from "styled-components";

import {ModalProvider} from "component-modal";
import {ConnectedErrorDisplay} from "./errors/ErrorHandler";
import SiteMap from "./SiteMap";

const store = configureStore(initialStore);


const theme = {
  calculatorHeaderColor: '#dddddd',
  calculatorBodyColor: '#f3f3f3',
  calculatorFooterColor: '#d9d9d9'
};

class App extends Component {
  componentDidMount(){
    var today = new Date(),
    date = today.getFullYear() + '' + (today.getMonth() + 1) + '' + today.getDate() +'_'+today.getTime();
    console.log('version :1-'+date);
  };
  render() {
    return (
      <Provider store={store}>
        <BrowserRouter basename={basename}>
          <ThemeProvider theme={theme}>
            <ModalProvider profile={'ci'}>
              <ConnectedErrorDisplay/>
              <RootRoute/>
            </ModalProvider>
          </ThemeProvider>
        </BrowserRouter>
      </Provider>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js